module.exports = __webpack_public_path__ + "files/65bb999242b7e0148765c619944cbd22.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-60x60.png
// module id = 747
// module chunks = 27